<template>
  <div class="c-table" ref="recordkpitable">
    <el-table class="common-el-table-styles" :data="data" :height="height" border stripe>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
      >
        <template slot-scope="scope">
          <span v-if="col.key === 'reportMonth'">{{ scope.row[col.key] }}</span>
          <div v-else-if="col.key === 'control'">
            <el-button type="text" size="small" @click="$emit('on-edit', scope.row)">修改</el-button>
            <Poptip confirm transfer title="您确认删除该绩效KPI吗？" @on-ok="$emit('on-del', scope.row)">
              <el-button type="text" size="small" class="c-control-margin">&ensp;删除</el-button>
            </Poptip>
          </div>
          <span v-else-if="col.key === 'thirtyDayKpiStr' && scope.row.roi1">
            ROI1：{{ scope.row.roi1 }}%，ROI2：{{ scope.row.roi2 }}%，ROI3：{{ scope.row.roi3 }}%，ROI4：{{ scope.row.roi4 }}%，ROI5：{{
              scope.row.roi5
            }}%
          </span>
          <span v-else-if="col.key === 'updateTime'">{{ scope.row[col.key] | datetimeToMin }}</span>
          <span v-else-if="col.key === 'createTime'">{{ scope.row[col.key] | datetimeToMin }}</span>
          <span v-else-if="col.key === 'isSpecial'">{{ scope.row[col.key] | transSpecial(scope.row) }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'recordKpiTable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    columns: {
      type: Array
    },
    height: {
      type: Number
    }
  },
  filters: {
    transSpecial(val, row) {
      let msgInfo
      switch (val) {
        case 1:
          msgInfo = '是'
          break
        case 2:
          msgInfo = '否'
          break
        default:
          msgInfo = '未知'
          break
      }
      return msgInfo
    }
  }
}
</script>
